__turbopack_context__.v({
  "gallery": "gallery-module__0H54GG__gallery",
  "galleryItem": "gallery-module__0H54GG__galleryItem",
  "galleryItemButton": "gallery-module__0H54GG__galleryItemButton",
  "galleryItemSelected": "gallery-module__0H54GG__galleryItemSelected",
  "header": "gallery-module__0H54GG__header",
  "image": "gallery-module__0H54GG__image",
  "imageWrapper": "gallery-module__0H54GG__imageWrapper",
  "images": "gallery-module__0H54GG__images",
  "scaleFadeIn": "gallery-module__0H54GG__scaleFadeIn",
  "stage": "gallery-module__0H54GG__stage",
  "thumbnailButton": "gallery-module__0H54GG__thumbnailButton",
  "thumbnails": "gallery-module__0H54GG__thumbnails",
  "title": "gallery-module__0H54GG__title",
  "wrapper": "gallery-module__0H54GG__wrapper",
});
